import { loadEgressProxyConfig } from "@/src/lib/egress-proxy";

import type { AxiosProxyConfig } from "axios";

const PROXIED_HOST_PATTERNS: readonly RegExp[] = [
  /^ecw\.texasneurology\.com$/,
  /\.eclinicalweb\.com$/,
  /\.ecwcloud\.com$/,
  /\.eclinicalworks\.com$/,
];

export function shouldRouteThroughEgressProxy(hostOrUrl: string): boolean {
  const hostname = hostOrUrl.includes("://") ? new URL(hostOrUrl).hostname : hostOrUrl;

  return PROXIED_HOST_PATTERNS.some((pattern) => pattern.test(hostname));
}

export function getEcwAxiosProxy(hostOrUrl: string): AxiosProxyConfig | false {
  if (!shouldRouteThroughEgressProxy(hostOrUrl)) return false;

  const { server, username, password } = loadEgressProxyConfig();

  return {
    protocol: server.protocol.replace(":", ""),
    host: server.hostname,
    port: Number(server.port),
    auth: { username, password },
  };
}
